const reverseUrl = (urlName, ...params) => DJ_CONST.reverse[urlName](...params);

export const buildUrl = (baseUrl, queryParamsObject) => {
    /* constructs URL from base url and query params object */

    // Map over pairs of query parameters and values.
    // If the parameter has a value, it is added to the URL, otherwise omitted.
    const queryString = Object.entries(queryParamsObject)
        .map(([param, value]) => (value ? `${param}=${value}` : null))
        .filter((param) => !!param)
        .join('&');

    // Only add the queryString to the URL if there are any query parameters.
    return `${baseUrl}${queryString ? `?${queryString}` : ''}`;
};

export default reverseUrl;



// WEBPACK FOOTER //
// ./src/utils/urls.js